import CommonFunctions from './CommonFunctions';

export function pageLogging(pageId) {
  if (!window.sa) return;
  try {
    window.sa('set', 'pageName', pageId);
    window.sa('send', 'pv', 'analysis');
  } catch (error) {
    console.log(error);
  }
}

export function sendLog(pageId, eventId, evenValue) {
  if (!window.sa) return;
  try {
    window.sa('set', 'eventName', eventId);
    window.sa('set', 'pageName', pageId);
    if (!CommonFunctions.isUndefinedOrNull(evenValue)) {
      window.sa('set', 'eventValue', evenValue);
    }
    window.sa('send', 'ev', 'analysis');
    // window.sa('send', 'ev');//the log is sent to both the testbed and the analysis server
  } catch (error) {
    console.log(error);
  }
}

export function sendAgree(pageId, eventId, customDimensionAgreeKey, agreeValues = []) {
  if (!window.sa) return;
  try {
    window.sa('set', 'eventName', eventId);
    window.sa('set', 'pageName', pageId);
    if(!CommonFunctions.isUndefinedOrNull(customDimensionAgreeKey)) {
      agreeValues.forEach( value => {
        window.sa('set', 'customDimension', customDimensionAgreeKey, value);
      });
    }
    window.sa('send', 'ev', 'analysis');
    // window.sa('send', 'ev');
  } catch (error) {
    console.log(error);
  }
}

